import { useEffect, useRef, useState } from "react";
import Render from "../pages/canvas/paper/render";
import DND from "../pages/canvas/paper/dndhandler";

export default function Grid(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (props.block.props.rows) {
      const _list = [];
      let num = 0;
      while (num < props.block.props.rows) {
        _list.push(num);
        num = num + 1;
      }
      setList(_list);
    }
  }, [props.block.props.rows]);

  return (
    <div
      ref={props.editorRef}
      style={{
        flexGrow: props.block.props.flexGrow,
        visibility: props.block.hidden ? "hidden" : "unset",
        backgroundColor: props.block.props.backgroundColor,
        display: "flex",
        ...props.block.props.size,
        overflowY: "scroll",
        position: "relative",
      }}
    >
      {list.map((number) => {
        if (number === 0) {
          return (
            <div style={{ flexGrow: 1, flexBasis: 0 }} key={number}>
              {props.children.map((block, index) => {
                const newPath = [...props.path];
                newPath.push(index);

                return (
                  <DND
                    key={block.id}
                    index={index}
                    path={newPath}
                    block={block}
                  >
                    <Render />
                  </DND>
                );
              })}
            </div>
          );
        }
        return (
          <div
            style={{ flexGrow: 1, flexBasis: 0, position: "relative" }}
            key={number}
          >
            {props.children.map((block, index) => {
              const newPath = [...props.path];
              newPath.push(index);

              return (
                <Render
                  key={block.id}
                  index={index}
                  path={newPath}
                  block={block}
                />
              );
            })}
            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 5,
                backgroundColor: "rgba(0,0,0,.15)",
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
